const SPM10 = "#F4F6FC";
const SPM50 = "#E7F3FD";
const SPM100 = "#CFE7FC";
const SPM200 = "#A0CFF8";
const SPM300 = "#70B7F5";
const SPM400 = "#409FF2";
const SPM500 = "#0D6CBF";
const SPM600 = "#0A5190";
const SPM700 = "#0A518F";
const SPM800 = "#07365F";
const SPM900 = "#07365F";
const lightBlue = "#556ED1";
const GRAY50 = "#F9FAFB";
const GRAY100 = "#F3F4F6";
const GRAY200 = "#E5E7EB";
const GRAY300 = "#D1D5DB";
const GRAY400 = "#9CA3AF";
const GRAY500 = "#6B7280";
const GRAY600 = "#475467";
const GRAY700 = "#374151";
const GRAY800 = "#1F2937";
const GRAY900 = "#101828";
const GRAY1000 = "#575757";
const RED700 = "#B91C1C";
const RED500 = "#EF4444";
const ORANGE500 = "#D1853E";
const success = "#81BD47";
const cancel = "#DC2626";
const error = "#D32F2F";
const WHITE = "#fff";

export default {
  success: success,
  error: error,
  cancel: cancel,
  lightBlue: lightBlue,
  GRAY50: GRAY50,
  GRAY100: GRAY100,
  GRAY200: GRAY200,
  GRAY300: GRAY300,
  GRAY400: GRAY400,
  GRAY500: GRAY500,
  GRAY600: GRAY600,
  GRAY700: GRAY700,
  GRAY800: GRAY800,
  GRAY900: GRAY900,
  GRAY1000,
  SPM10: SPM10,
  SPM50: SPM50,
  SPM100: SPM100,
  SPM200: SPM200,
  SPM300: SPM300,
  SPM400: SPM400,
  SPM500: SPM500,
  SPM600: SPM600,
  SPM700: SPM700,
  SPM800: SPM800,
  SPM900: SPM900,
  WHITE,
  RED700,
  RED500,
  ORANGE500,
};
